import Phaser from 'phaser';
import { COLORS } from '../main';

export interface GameOverData {
  phase: 'Win' | 'Loss';
}

export class GameOverScene extends Phaser.Scene {
  result!: GameOverData;

  constructor() {
    super('GameOver');
  }

  init(data: GameOverData): void {
    this.result = data;
  }

  create(): void {
    const { width, height } = this.scale;
    const isWin = this.result.phase === 'Win';

    this.add
      .text(width / 2, height * 0.32, isWin ? 'YOU WIN' : 'GAME OVER', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '48px',
        fontStyle: 'bold',
        color: isWin ? '#34d399' : '#ef4444',
      })
      .setOrigin(0.5);

    this.add
      .text(
        width / 2,
        height * 0.45,
        isWin ? 'You reached the apex of the pyramid!' : 'Your bag ran dry.',
        {
          fontFamily: 'system-ui, sans-serif',
          fontSize: '16px',
          color: '#e6edf3',
          align: 'center',
          wordWrap: { width: width * 0.85 },
        }
      )
      .setOrigin(0.5);

    this.makeButton(width / 2, height * 0.68, 'Play Again', () => {
      this.scene.start('Menu');
    });
  }

  private makeButton(x: number, y: number, label: string, onClick: () => void): void {
    const w = 180;
    const h = 52;
    const bg = this.add
      .rectangle(x, y, w, h, COLORS.accent)
      .setStrokeStyle(2, COLORS.border)
      .setInteractive({ useHandCursor: true });
    this.add
      .text(x, y, label, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '20px',
        fontStyle: 'bold',
        color: '#0d1117',
      })
      .setOrigin(0.5);
    bg.on('pointerdown', onClick);
  }
}
